'use strict';

angular.module('app.StaticMessage', [])

.controller('StaticMessage', ['$scope', '$sce', '$http', '$modal', '$translate',
function ($scope, $sce, $http, $modal, $translate) {


    var scopeModal = $scope.$new(true);
    scopeModal.staticMessage = null;

    var showStaticDialog = $modal({
        scope: scopeModal,
        title: $translate.instant('iam.shared.helpers.staticMessage.information'),
        placement: 'center',
        template: require('./staticMessageCtrl.tpl.html'),
        controller: 'StaticMessage',
        show: false
    });

    $scope.showStaticDialog = function () {
      $http.get('/Page/Help')
          .then(function (response) {

              scopeModal.staticMessage = $sce.trustAsHtml(response.data);;
          });

        showStaticDialog.$promise.then(showStaticDialog.show);
    };
}]);
